import moment from "moment";
import * as Yup from "yup";

export const AddMournersSchema = Yup.object().shape({
  mourners_list: Yup.string().required("Add one mourner at least"),
});
export const AddittionalInformationSchema = Yup.object().shape({
  about_deceased: Yup.string().max(180, "Must be at most 180 characters"),
  cemetery: Yup.string().max(180, "Must be at most 180 characters"),
  plaques_number: Yup.string().max(180, "Must be at most 180 characters"),
});
export const DeceacedDetailsSchema = Yup.object().shape({
  firstName: Yup.string()
    .required("Name is required")
    .max(40, "First Name must be at most 40 characters")
    .matches(/^[^\s]+(\s+[^\s]+)*$/, "Name should not start with spaces"),
  lastName: Yup.string()
    .required("Name is required")
    .max(40, "Last Name must be at most 40 characters")
    .matches(/^[^\s]+(\s+[^\s]+)*$/, "Name should not start with spaces"),
  hebrew_name: Yup.string().max(40, "Hebrew name must be at most 40 characters"),
  date_of_death: Yup.string()
    .required("Required")
    .test("DOB", "Please select valid date of death", (value) => {
      return moment().diff(moment(value), "days") + 1 > 0;
    }),
});
